import Konva from "konva";

/**
 * 既存の固定マスクレイヤーの初期化
 * @param layer
 */
export function initTabletMaskLayer(layer) {
  // Imageを左右に置く
  let shape = new Konva.Rect({
    x: 0,
    y: 0,
    width: 1164,
    height: 1080,
    fill: '#141414',
  });
  layer.add(shape);
  let shape2 = new Konva.Rect({
    x: 2676,
    y: 0,
    width: 1164,
    height: 1080,
    fill: '#141414',
  });
  layer.add(shape2);
}

/**
 * ユーザー書き込み可能領域の可視化レイヤーを初期化
 * @param layer - Konvaレイヤー
 * @param restrictImgUrl - restrict_image_urlのURL
 * @param options - 表示オプション
 */
let cachedImageObj = null;

export function initUserAreaVisualizationLayer(layer, restrictImgUrl, options = {}) {
  if (!restrictImgUrl) {
    console.warn('No restrict image URL provided');
    return;
  }

  const imageObj = new Image();
  imageObj.onload = function() {
    cachedImageObj = imageObj;
    updateUserAreaVisualization(layer, options);
  };
  
  imageObj.onerror = function() {
    console.error('Failed to load restrict image:', restrictImgUrl);
  };
  
  imageObj.src = restrictImgUrl;
}

/**
 * ユーザー書き込み可能領域の表示を更新
 * @param layer - Konvaレイヤー
 * @param options - 表示オプション
 */
export function updateUserAreaVisualization(layer, options = {}) {
  if (!cachedImageObj) {
    console.warn('No cached image object available');
    return;
  }

  // レイヤーをクリア
  layer.removeChildren();

  // 背景として半透明の白い矩形を追加
  const bgRect = new Konva.Rect({
    x: 0,
    y: 0,
    width: 3820,
    height: 1080,
    fill: 'white',
    opacity: 0.3
  });
  layer.add(bgRect);

  // マスク画像を追加
  const restrictImage = new Konva.Image({
    x: 0,
    y: 0,
    image: cachedImageObj,
    width: 3820,
    height: 1080,
    globalCompositeOperation: options.invert ? 'destination-out' : 'source-out'
  });
  layer.add(restrictImage);
  
  layer.batchDraw();
}

/**
 * タブレットの画像保存するときのマスクされた画像を返す
 */
export function drawMaskedImage(canvas, x, y, width, height) {
  const resizedCanvas = document.createElement("canvas");
  const resizedContext = resizedCanvas.getContext("2d");
  resizedCanvas.height = height;
  resizedCanvas.width = width;
  resizedContext.drawImage(canvas, x, y, width, height, 0, 0, width, height);
  return resizedCanvas.toDataURL("image/png");
}
